// function shouldShowPlayStore(url) {
//     try {
//       const parsedUrl = new URL(url);
//       const showPlayStore = parsedUrl.searchParams.get("showPlayStore");
//       return showPlayStore !== "false";
//     } catch (error) {
//       console.error("Invalid URL:", error);
//       return true; // default to true if URL is invalid
//     }
//   }

export default function shouldShowPlayStore() {
    const params = new URLSearchParams(window.location.search);
    return params.get("showPlayStore") !== "false";
}
